import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './hooks/useAuth.jsx'
import { NotificationProvider } from './contexts/NotificationContext'
import { TenantThemeProvider } from './providers/TenantThemeProvider'
import App from './App.jsx'
import './index.css'
import { registerSW } from 'virtual:pwa-register'

// Create a client
const updateSW = registerSW({
	onNeedRefresh() {
		if (confirm('Nueva versión disponible. ¿Deseas actualizar?')) {
			updateSW(true)
		}
	},
	onOfflineReady() {
		console.log('La aplicación está lista para funcionar sin conexión')
	},
})

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 1,
			refetchOnWindowFocus: false,
			staleTime: 5 * 60 * 1000, // 5 minutes
		},
	},
})

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<BrowserRouter>
				<AuthProvider>
					<TenantThemeProvider>
						<NotificationProvider>
							<App />
						</NotificationProvider>
					</TenantThemeProvider>
					<Toaster
						position="top-right"
						containerStyle={{ zIndex: 99999 }}
						toastOptions={{
							duration: 4000,
							style: {
								background: '#363636',
								color: '#fff',
							},
							success: {
								duration: 3000,
								iconTheme: {
									primary: '#10b981',
									secondary: '#fff',
								},
							},
							error: {
								duration: 5000,
								iconTheme: {
									primary: '#ef4444',
									secondary: '#fff',
								},
							},
						}}
					/>
				</AuthProvider>
			</BrowserRouter>
		</QueryClientProvider>
	</React.StrictMode>,
)
